var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Multiselect',{class:{
    'scrollable': (_vm.saleReps || []).length > 7,
  },attrs:{"multiple":true,"options":_vm.saleReps || [],"taggable":true,"label":"name","track-by":"name"},on:{"tag":_vm.addSaleRepType},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }